import { Flex, Modal, Button, Checkbox, message } from "antd";
import { useTranslation } from "react-i18next";
import successImg from "@/assets/svg/success.svg";
import {
  computedArticleTaxMoney,
  goH5PayHref,
  goHref,
  IS_MOBILE,
  toLogin,
} from "@/utils/tool";
import {
  allInPayApp,
  allInPayCard,
  allInPayH5,
  allInPayQrcode,
  commitOrder,
  createPodOrder,
  getPayMethod,
  OrderDetail,
  wxH5Pay,
  wxPay,
} from "@/api/order";
import { useMemo, useState } from "react";
import {
  allInPayTypeMap,
  PayWay,
  payWayList,
  podVersionNameMap,
} from "@/utils/contants";
import OfflineModal from "@/components/Modal/Offline";
import WxPay from "@/components/PayMask/WxPay";

import "./index.scss";
import style from "./custom.module.scss";
import { Form, Input } from "antd";
import { useEffect } from "react";
import { getUser } from "@/api/config";
import { useNavigate } from "react-router";
import { math } from "@/utils/math";
import { Select } from "antd";

type Props = {
  order: PersonalOrder | PodOrder;
  // 是否是继续支付，继续支付不需要填纸本信息
  isProceedPay?: boolean;
  cancelModal: () => void;
};
const PodConfirm = ({ order, isProceedPay = false, cancelModal }: Props) => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const user = getUser();
  const { t, i18n } = useTranslation();
  // 将表单声明移到组件外部
  const [buyJournalForm] = Form.useForm<{
    receive: {
      address: string;
      contact: string;
      phone: string;
    };
  }>();
  const [payList, setPayList] = useState<number[]>([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [pod_tax_money, setPodTaxMoney] = useState(0);
  const [way, setWay] = useState<PayWay>(PayWay.Wx);
  const [transaction_id, setTransaction_id] = useState("");
  const [showWxPay, setShowWxPay] = useState(false);
  const [payUrl, setPayUrl] = useState("");
  const [modalInstance, setModalInstance] = useState(false);
  const [protocol, setProtocol] = useState(false);
  // 出版社启用的 pod 版本
  const [podVersions, setPodVersions] = useState<
    Array<{ type: number; price: number }>
  >([]);
  // 各版本定购数量（key 为版本类型 1：黑白版 2：彩色版）
  const [numbers, setNumbers] = useState<Record<number, number>>({});
  const [podPayInfo, setPodPayInfo] = useState<{
    order_ids: string[];
    total_amounts: number[];
  }>();

  // 数量选项 0-100，0 表示不订该版本
  const numOptions = useMemo(() => {
    return Array.from({ length: 101 }, (_, i) => ({
      label: `${i}`,
      value: i,
    }));
  }, []);

  /**
   * 获取支付方式列表
   * @returns
   */
  const getWayList = async () => {
    const res = await getPayMethod<{
      pay_methods: Array<PayWay>;
    }>({ order_id: order.order_id });
    if (res.code === 0) {
      const methods = res.data.pay_methods;
      if (methods[0]) {
        setWay(methods[0]);
      }
      setPayList(methods);
      return;
    }
    messageApi.error(res.msg);
  };

  /**
   * 确认支付
   */
  const confirmPay = async () => {
    if (!user) {
      toLogin();
      return;
    }
    if (!way) {
      messageApi.error(t("支付方式不能为空"));
      return;
    }
    if (!protocol) {
      messageApi.info(t("请勾选“我已阅读 PubLink 使用协议”"));
      return;
    }
    // sentry4Action("确认支付", {
    //   order_id: order.order_id,
    //   order_type: order.expense_type,
    //   publishing_house_name: order.publishing_house_name,
    //   journal_name: order.journal_name,
    //   article_title: order.article_title,
    //   cae: order.contact_author_email.split("@").join(" "),
    //   meeting_name: order?.meeting_name,
    // });

    const podOrderData = {
      orderIds: [] as string[],
      totalAmounts: [] as number[],
    };
    // 继续支付不需要重新生成pod订单
    if (!isProceedPay) {
      setPodPayInfo(undefined);
      try {
        const data = await buyJournalForm.validateFields();
        // 数量大于 0 的版本
        const targetVersions = podVersions.filter(
          (version) => (numbers[version.type] || 0) > 0,
        );
        if (!targetVersions.length) {
          messageApi.error(`${t("数量")}${t("不能为空")}`);
          return;
        }
        // 每个版本各创建一个 pod 订单
        for (const version of targetVersions) {
          const res = await createPodOrder<{
            order_id: string;
            total_amount: number;
          }>({
            apc_order_id: order.order_id,
            bill: undefined,
            type: version.type,
            number: numbers[version.type],
            receive: data.receive,
          });
          if (res.code !== 0) {
            messageApi.error(res.msg);
            return;
          }
          podOrderData.orderIds.push(res.data.order_id);
          podOrderData.totalAmounts.push(res.data.total_amount);
        }
        if (way === PayWay.Offline)
          setPodPayInfo({
            order_ids: [...podOrderData.orderIds],
            total_amounts: [...podOrderData.totalAmounts],
          });
      } catch (error) {}
      if (!podOrderData.orderIds.length) return;
    }

    try {
      if (way === PayWay.Offline) {
        setModalInstance(true);
        return;
      }

      //   setPayLoading(true);
      const res = await commitOrder<{ transaction_id: string }>({
        bill: undefined,
        order_ids: isProceedPay ? [order.order_id] : podOrderData.orderIds,
        pay_money: isProceedPay ? [totalPrice] : podOrderData.totalAmounts,
      });
      //   setPayLoading(false);
      if (res.code === 0) {
        const transaction_id = res.data.transaction_id;
        setTransaction_id(transaction_id);
        if (way === PayWay.Card) {
          cardPayHandle(transaction_id);
        } else if (IS_MOBILE && way === PayWay.Wx) {
          wxH5PayHandle(transaction_id);
        } else if (IS_MOBILE && way === PayWay.Yinlian) {
          h5PayHandle(transaction_id);
        } else if (IS_MOBILE) {
          appPayHandle(transaction_id);
        } else {
          qrPayHandle(transaction_id);
        }
      } else if (res.code === 200002) {
        location.reload();
      } else {
        messageApi.error(res.msg);
      }
    } catch (error) {
      //   Sentry.captureException(new Error("custom error 2"));
    }
  };

  /**
   * 计算总金额与增值税（总金额 = Σ 版本单价 × 数量）
   */
  const computeTotal = (
    versions: Array<{ type: number; price: number }>,
    nums: Record<number, number>,
  ) => {
    const total = versions.reduce((sum, version) => {
      return Number(
        math
          .add(
            math.bignumber(sum),
            math.multiply(
              math.bignumber(version.price),
              math.bignumber(nums[version.type] || 0),
            ),
          )
          .toString(),
      );
    }, 0);
    setTotalPrice(total);
    setPodTaxMoney(computedArticleTaxMoney(total));
  };

  // 监听数量变化，更新本地状态和金额
  const onNumberChange = (type: number, value: number) => {
    const nextNumbers = { ...numbers, [type]: value };
    setNumbers(nextNumbers);
    computeTotal(podVersions, nextNumbers);
  };

  /**
   * 从支付链接解析参数，获取订单详情中的 pod 版本信息
   */
  const getPodVersions = async () => {
    const payUrl = (order as PersonalOrder).pay_url;
    if (!payUrl) return;
    try {
      const url = new URL(payUrl);
      const res = await OrderDetail<Order>({
        order_id: url.searchParams.get("order-id") || "",
        sign: url.searchParams.get("sign") || "",
      });
      if (res.code === 0) {
        const versions = res.data.pod_versions || [];
        setPodVersions(versions);
        // 默认数量为 1
        const initNumbers = versions.reduce<Record<number, number>>(
          (acc, version) => {
            acc[version.type] = 1;
            return acc;
          },
          {},
        );
        setNumbers(initNumbers);
        computeTotal(versions, initNumbers);
        return;
      }
      messageApi.error(res.msg);
    } catch (error) {}
  };

  /**
   * 通联 H5 网关：拿到地址和表单后由浏览器 POST 跳转，拉起云闪付
   */
  const h5PayHandle = async (transaction_id: string) => {
    const payRes = await allInPayH5<{
      url: string;
      sandbox: boolean;
      form: Record<string, string>;
    }>({
      transaction_id,
    });
    if (payRes.code === 0) {
      if (payRes.data.sandbox) {
        navigate("/result?transaction_id=" + transaction_id);
        return;
      }
      submitPayForm(payRes.data.url, payRes.data.form);
      return;
    }
    messageApi.error(payRes.msg);
  };

  /**
   * 通联银行卡支付：拿到地址和表单后由浏览器 POST 跳转
   */
  const cardPayHandle = async (transaction_id: string) => {
    const payRes = await allInPayCard<{
      url: string;
      sandbox: boolean;
      form: Record<string, string>;
    }>({
      transaction_id,
    });
    if (payRes.code === 0) {
      if (payRes.data.sandbox) {
        navigate("/result?transaction_id=" + transaction_id);
        return;
      }
      submitPayForm(payRes.data.url, payRes.data.form);
      return;
    }
    messageApi.error(payRes.msg);
  };

  const submitPayForm = (url: string, form: Record<string, string>) => {
    const formEl = document.createElement("form");
    formEl.method = "POST";
    formEl.action = url;
    formEl.acceptCharset = "UTF-8";
    Object.entries(form || {}).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      formEl.appendChild(input);
    });
    document.body.appendChild(formEl);
    formEl.submit();
  };

  /**
   * 微信 H5：打开支付链接，离开页面后进入等待结果页
   */
  const wxH5PayHandle = async (transaction_id: string) => {
    const wxRes = await wxH5Pay<{ url: string; sandbox: boolean }>({
      transaction_id,
    });
    if (wxRes.code === 0) {
      if (wxRes.data.sandbox) {
        navigate(`/wrap/wait-result/${transaction_id}`);
        return;
      }
      const redirectUrl =
        import.meta.env.VITE_WX_REDIRECT +
        "/wrap/wait-result/" +
        transaction_id;
      const redirectFn = () => {
        if (document.visibilityState === "hidden") {
          document.removeEventListener("visibilitychange", redirectFn);
          navigate(`/wrap/wait-result/${transaction_id}`, {
            replace: true,
          });
        }
      };
      document.addEventListener("visibilitychange", redirectFn);
      goH5PayHref(
        `${wxRes.data.url}&redirect_url=${encodeURIComponent(redirectUrl)}`,
      );
      return;
    }
    messageApi.error(wxRes.msg);
  };

  /**
   * 通联 APP 支付：新标签页打开支付地址，当前页进入等待结果页
   */
  const appPayHandle = async (transaction_id: string) => {
    const payType = allInPayTypeMap[way];
    if (!payType) return;
    const payRes = await allInPayApp<{ url: string; sandbox: boolean }>({
      transaction_id,
      pay_type: payType,
    });
    if (payRes.code === 0) {
      if (payRes.data.sandbox) {
        navigate("/result?transaction_id=" + transaction_id);
        return;
      }
      goHref(payRes.data.url);
      navigate(`/wrap/wait-result/${transaction_id}`, { replace: true });
      return;
    }
    messageApi.error(payRes.msg);
  };

  /**
   * 二维码支付。PC 微信直连微信支付，支付宝和银联走通联。
   */
  const qrPayHandle = async (transaction_id: string) => {
    if (way === PayWay.Wx) {
      const wxRes = await wxPay<{ url: string; sandbox: boolean }>({
        transaction_id,
      });
      if (wxRes.code === 0) {
        if (wxRes.data.sandbox) {
          navigate("/result?transaction_id=" + transaction_id);
          return;
        }
        setShowWxPay(true);
        setPayUrl(wxRes.data.url);
        return;
      }
      messageApi.error(wxRes.msg);
      return;
    }
    const payType = allInPayTypeMap[way];
    if (!payType) return;
    const payRes = await allInPayQrcode<{ url: string; sandbox: boolean }>({
      transaction_id,
      pay_type: payType,
    });
    if (payRes.code === 0) {
      if (payRes.data.sandbox) {
        navigate("/result?transaction_id=" + transaction_id);
        return;
      }
      setShowWxPay(true);
      setPayUrl(payRes.data.url);
      return;
    }
    messageApi.error(payRes.msg);
  };

  /**
   * 协议选中
   * @param e
   */
  const check = (e) => {
    setProtocol(!protocol);
  };

  useEffect(() => {
    if (isProceedPay) {
      const total = (order as PodOrder).total_amount;
      setTotalPrice(total);
      setPodTaxMoney(computedArticleTaxMoney(total));
      setPodPayInfo({
        order_ids: [order.order_id],
        total_amounts: [total],
      });
      return;
    }
    getPodVersions();
  }, []);

  // 初始化支付方式与金额
  useEffect(() => {
    getWayList();
  }, [order]);

  return (
    <div>
      {contextHolder}
      <Modal
        open
        wrapClassName="modal-wrapper"
        onCancel={cancelModal}
        footer={null}
        width={
          isProceedPay ? "auto" : i18n.language === "en" ? "900px" : "832px"
        }
        title={t("确认订单")}
        centered
        maskClosable={false}
        styles={{
          body: {
            padding: 40,
          },
        }}
      >
        <Flex className={style.podConfirmBox}>
          {!isProceedPay && (
            <div className="left-form">
              <Form
                layout="horizontal"
                labelCol={{
                  style: { width: i18n.language === "en" ? 180 : 100 },
                }}
                labelAlign="left"
                form={buyJournalForm}
              >
                <Form.Item label={t("定购信息")} colon={false}>
                  <div>
                    {podVersions.map((version) => (
                      <div
                        key={version.type}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 24,
                          marginBottom: 12,
                        }}
                      >
                        <span>
                          {t(podVersionNameMap[version.type])}-{t("单价")}：
                          {`¥${version.price.toFixed(2)}/${t("本")}`}
                        </span>
                        <span>
                          {t("数量")}：
                          <Select
                            style={{ width: 120 }}
                            options={numOptions}
                            value={numbers[version.type] ?? 1}
                            onChange={(val) =>
                              onNumberChange(version.type, val)
                            }
                          />
                        </span>
                      </div>
                    ))}
                  </div>
                </Form.Item>
                <Form.Item
                  label={t("收件人姓名")}
                  name={["receive", "contact"]}
                  rules={[
                    {
                      required: true,
                      message: `${t("收件人姓名")}${t("不能为空")}`,
                    },
                    {
                      max: 80,
                      message: `${t("maxChart", { count: 80 })}`,
                    },
                  ]}
                >
                  <Input placeholder={t("必填") as string} />
                </Form.Item>
                <Form.Item
                  name={["receive", "phone"]}
                  label={t("收件人手机号")}
                  rules={[
                    {
                      required: true,
                      message: `${t("收件人手机号")}${t("不能为空")}`,
                    },
                    {
                      pattern: new RegExp(/^[1|8]\d{10}$/i),
                      message: t("输入的手机号不正确"),
                    },
                  ]}
                >
                  <Input placeholder={t("必填") as string} />
                </Form.Item>
                <Form.Item
                  label={t("收件地址")}
                  name={["receive", "address"]}
                  rules={[
                    {
                      required: true,
                      message: `${t("收件地址")}${t("不能为空")}`,
                    },
                    {
                      max: 200,
                      message: `${t("maxChart", { count: 200 })}`,
                    },
                  ]}
                >
                  <Input.TextArea rows={4} placeholder={t("必填") as string} />
                </Form.Item>
              </Form>
              <Flex className="buy-journal-remark" gap={8} vertical>
                <div>
                  {t(
                    "1、我们采用按需印刷的方式为您提供纸本期刊服务，订单下单后除质量问题外不支持退定，如遇质量问题请与客服联系。"
                  )}
                </div>
                <div>{t("2、当期期刊正式出版后45个工作日内发货。")}</div>
                <div>{t("3、您随后可在个人中心查看订单及物流信息。")}</div>
              </Flex>
            </div>
          )}

          <div className={style["fee-box"]}>
            <span className={style["fee-title"]}>{t("费用明细")}</span>
            <div className={`fee-detail ${IS_MOBILE && "mobile-fee-detail"}`}>
              <div
                className="fee-info"
                style={IS_MOBILE ? { borderRadius: "8px" } : {}}
              >
                <div className="info-money">
                  <div
                    className="mark"
                    style={IS_MOBILE ? { paddingTop: "12px" } : {}}
                  >
                    {t("需支付金额")}
                  </div>
                  <div className="price">
                    <span>¥</span>
                    <span>{totalPrice}</span>
                  </div>
                </div>

                <>
                  <div
                    className="info-item"
                    style={IS_MOBILE ? { padding: "1rem 1rem 0" } : {}}
                  >
                    <span>{t("增值税")}</span>
                    <span>¥{pod_tax_money.toFixed(2)}</span>
                  </div>
                </>
              </div>

              <div
                className="way-box"
                style={IS_MOBILE ? { paddingLeft: 12, paddingRight: 12 } : {}}
              >
                <div
                  className="way-title"
                  style={IS_MOBILE ? { marginTop: 0 } : {}}
                >
                  <span>{t("支付方式")}</span>
                </div>
                <div
                  className="pay-list"
                  style={
                    payList.length == 2
                      ? { justifyContent: "flex-start", columnGap: "20px" }
                      : {}
                  }
                >
                  {payList.map((_way) => {
                    const payWay = payWayList[_way];
                    if (!payWay) return null;
                    return (
                      <span
                        key={_way}
                        className={way === _way ? "pay-selected" : ""}
                        onClick={() => {
                          setWay(_way);
                        }}
                        style={payList.length == 2 ? { flex: 1 } : {}}
                      >
                        {way === _way && (
                          <img
                            className="success-icon"
                            src={successImg}
                            alt=""
                          />
                        )}
                        <img className="pay-icon" src={payWay.src} alt="" />
                        <span className="pay-label">{t(payWay.value)}</span>
                      </span>
                    );
                  })}
                </div>
                <div className="pay-tip">
                  {t("公务卡支付请选择信用卡/借记卡支付")}
                </div>
              </div>
            </div>
            <Button
              type="primary"
              className={style["confirm-pay"]}
              onClick={confirmPay}
              // loading={payLoading}
            >
              {t("确认支付")}
            </Button>
            <Checkbox
              className={style["protocol"]}
              checked={protocol}
              onChange={check}
            >
              <span> {t("我已阅读并同意 PubLink")} </span>
              <a className="light" href="/agreement/use.html" target="_blank">
                {t("使用协议")}
              </a>
              <span> {t("和")} </span>
              <a
                className="light"
                href="/agreement/privacy.html"
                target="_blank"
              >
                {t("隐私协议")}
              </a>
            </Checkbox>
          </div>
        </Flex>
      </Modal>
      {showWxPay && (
        <WxPay
          way={way}
          value={{
            url: payUrl,
            money: totalPrice,
            transaction_id: transaction_id,
          }}
          confirm={() => {
            setShowWxPay(false);
          }}
          cancel={() => {
            setShowWxPay(false);
          }}
        ></WxPay>
      )}

      {modalInstance && (
        <OfflineModal
          hiddenModal={() => setModalInstance(false)}
          actionParams={{
            bill: undefined,
            order_ids: podPayInfo?.order_ids || [],
            pay_money: podPayInfo?.total_amounts || [],
          }}
        />
      )}
    </div>
  );
};

export default PodConfirm;
